// +----------------------------------------------------------------------
// | CNXRC [ CNXRC赋能开发者，助力企业发展 ]
// +----------------------------------------------------------------------
// | Copyright (c) 2016~2026 https://www.cnxrc.net All rights reserved.
// +----------------------------------------------------------------------
// | Licensed CNXRC并不是自由软件，未经许可不能去掉CNXRC相关版权
// +----------------------------------------------------------------------
// | Author: CNXRC Team <admin@cnxrc.net>
// +----------------------------------------------------------------------

import request from '@/utils/request';
import { isPlatform } from '@/utils/settingMer';

/**
 * @description 协议管理-- 详情
 */
export function agreementInfoApi(data) {
  if (!isPlatform) {
    return request.get("admin/business/agreement/member/card/open/info");
  }
  return request.get("admin/platform/agreement/".concat(data));
}

/**
 * @description 协议管理-- 保存
 */
export function agreementSaveApi(save, data) {
  if (!isPlatform) {
    return request({
      url: "admin/business/agreement/member/card/open/save",
      method: 'POST',
      data: data
    });
  }
  // return request.post(`admin/platform/agreement/${save}`, data);
  return request({
    url: "admin/platform/agreement/".concat(save),
    method: 'POST',
    data: data
  });
}